import qs from 'query-string'
import React from 'react'
import { Trans } from 'react-i18next'
export const showLoginErrorMessages = (error) => {
  switch (error) {
    case 401:
      return <Trans>Lo sentimos, has introducido un usuario o contraseña incorrecta</Trans>
    case 422:
      return <Trans>Se ha producido un error, porfavor revisa las credenciales introducidas</Trans>
    case 460:
      return <Trans>La contraseña se ha caducado, os redirigimos a una pagina para poder resetearla</Trans>
    case 461:
      return <Trans>La contraseña introducida ya se ha utilizado anteriormente</Trans>
    case 'no-password':
      return <Trans>Falta la contraseña</Trans>
    case 'no-email':
      return <Trans>No Has Introducido un mail</Trans>
    case 'no-gpid':
      return <Trans>No Has Introducido un GPID</Trans>
    case 'no-passwords-match':
      return <Trans>Las contraseñas no coinciden</Trans>
    default:
      return <Trans>Lo sentimos, has introducido un usuario o contraseña incorrecta</Trans>
  }
}
export const getSearchLocation = (props) => {
  if (props.location) return qs.parse(props.location.search)
}
export const getParams = (historyProps) => {
  if (historyProps.match.params) return { ...historyProps.match.params }
}
export const getParamId = (routerProps) => {
  return routerProps?.match?.params?.id || null
}
